import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    data() {
        return {
            form: {
                chocolateSharpeners: [],
                chocolateSharpener: {
                    couverture: {
                        weight: 0
                    },
                }
            },
            chocolateSharpenerSizes: [
                { name: "Duży", id: 2 },
                { name: "Mały", id: 1 },
            ],
            chocolateSharpenerSizeSmall: 1,
            chocolateSharpenerSizeBig: 2,
        }
    },
    methods: {
        assignCouvertureToChocolateSharpener: async function (couvertureId, chocolateSharpenerId) {
            return axios.post(`${serverUrl}ChocolateSharpener/AssignCouvertureToChocolateSharpener`,
                {
                    couvertureId,
                    chocolateSharpenerId
                }
            )
        },

        getChocolateSharpeners() {
            return axios.get(`${serverUrl}ChocolateSharpener/LoadChocolateSharpeners`
            )
        },

        getChocolateSharpenerById(coatingProductMachineId) {
            const that = this;
            axios.get(`${serverUrl}ChocolateSharpener/LoadChocolateSharpenerById/${coatingProductMachineId}`)
                .then((res) => {
                    const result = res.data;
                    if (result.success) {
                        that.form.chocolateSharpener = result.data
                        that.chocolateSharpeners = [{ label: result.data.name, value: result.data.machineId }]
                        that.form.coolingTunnel = that.coolingTunnels.filter(x => x.id == result.data.coolingTunnelId)[0]
                    } else {
                        that.DisplayError("Błąd", result.errors[0])
                    }
                })
                .catch(() => {
                    that.DisplayError("Błąd", "Nie udało się pobrać temperówki")
                })
                .finally(() => {
                    that.isLoaded = true;
                })
        },

        takeOutCouvertureFromChocolateSharpener(coatingProductMachineId) {
            return axios.post(`${serverUrl}ChocolateSharpener/TakeOutCouvertureFromChocolateSharpener`,
                {
                    coatingProductMachineId
                }
            )
        }
    },
};
